import { parseJwt } from './parseJwt';

export interface ShellUser {
  /** The user's catalog entity ref, e.g. `user:default/jane.doe`. */
  userEntityRef: string;
  email: string;
  displayName: string;
  picture?: string;
}

/**
 * Reads the user from an auth-api access token, which carries the entity ref in
 * `sub` and the address in `user_email`.
 */
export function userFromJwt(jwt: string | null | undefined): ShellUser | null {
  if (!jwt) return null;
  const payload = parseJwt(jwt);
  if (!payload) return null;
  const userEntityRef = typeof payload.sub === 'string' ? payload.sub : '';
  const email = typeof payload.user_email === 'string' ? payload.user_email : '';
  return {
    userEntityRef,
    email,
    displayName:
      (payload.name as string) || (payload.preferred_username as string) || email || 'User',
    picture: (payload.picture as string) || undefined,
  };
}
